function delayedNavigation(router, routeName, delay = 2000) {
  setTimeout(() => {
    router.push({ name: routeName });
  }, delay);
}

export default delayedNavigation;



// WEBPACK FOOTER //
// ./src/common/utils/navigation.js